import { AnalyticsEvent } from '../../core/AnalyticsEvent'
import { VoucherViewEventSchema } from '../../schemas/voucher/VoucherViewEventSchema'
import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'
import { CommonEventParams, getCommonParams } from '../../utils/CommonParams'
import { EVENT_CATEGORY } from '../../constants/EventHelper'

export interface VoucherViewEventParams extends CommonEventParams {
  BUSINESS_VERTICAL: string
  EVENT_CATEGORY: string
  OFFER_ID: string
  OFFER_TYPE: string
  OFFER_SAP_REFERENCE: string | null
  VOUCHER_NAME: string
  VOUCHER_CODE: string
  VOUCHER_POSITION: number
  STORE_ID_SAP: string
  STORE_ID_DBP: string
  STORE: string
}

export class VoucherViewEvent extends AnalyticsEvent {
  constructor(params: VoucherViewEventParams) {
    super(VoucherViewEventSchema(), ['segment'])
    this.createEventObject(params)
  }
}

export async function trackVoucherViewedEvent(
  voucherViewParams: VoucherViewEventParams
): Promise<void> {
  const { isEnabled = false } = getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_THREE) || {}
  if (isEnabled) {
    const params: VoucherViewEventParams = {
      ...getCommonParams(),
      ...voucherViewParams,
      BUSINESS_VERTICAL: voucherViewParams.BUSINESS_VERTICAL,
      EVENT_CATEGORY: EVENT_CATEGORY.VOUCHER,
    }
    new VoucherViewEvent(params).track()
  }
}
